// @flow
import {
    openNotificationsPopover,
    closeNotificationsPopover,
    fetchNotifications,
    fetchNotificationsSuccess,
    fetchNotificationsFailure,
    setOpenedAtSuccess,
    setViewedAtSuccess
} from "../actions/notifications.actions";
import { handleActions } from "redux-actions";
import { setupPagedRequest } from "./request.reducer";
import { PagedRequest } from "../records/request.record";
import Record from "../flow/Record";
import { jsToNotificationRecord } from "../records/notification.record";

export class Notifications extends Record({
    notificationsPagedRequest: new PagedRequest(),
    open: false
}) {
    notificationsPagedRequest: PagedRequest;
    open: boolean;
}

const request = setupPagedRequest(
    "notificationsPagedRequest",
    "notifications",
    jsToNotificationRecord
);

function setDate(dateParam) {
    return (state, { payload }) => {
        const id = payload && payload.id;
        return request.map(state, node => {
            if (!node[dateParam] && (!id || id === node.postId)) {
                return node.set(dateParam, new Date());
            }
            return node;
        });
    };
}

const notifications = handleActions(
    {
        [openNotificationsPopover](state) {
            return state.set("open", true);
        },
        [closeNotificationsPopover](state) {
            return state.set("open", false);
        },
        [fetchNotifications]: request.start,
        [fetchNotificationsSuccess](state, action) {
            if (action.payload.reset) {
                console.log("reset");
                state = request.reset(state);
            }
            return request.filter(request.success(state, action), node => {
                return !!(node.actingUser && node.post);
            });
        },
        [fetchNotificationsFailure]: request.failure,
        [setOpenedAtSuccess]: setDate("openedAtDate"),
        [setViewedAtSuccess]: setDate("viewedAtDate")
    },
    new Notifications()
);

export default notifications;



// WEBPACK FOOTER //
// ./src/reducers/notifications.reducer.js